export const GET_TESTIMONIALS_LIST = 'GET_TESTIMONIALS_LIST'
